import { DrawAction, DrawActionElement, DrawOptions } from '../draw-action';
import { FigureDrawAction } from './figure-draw-action';

declare const fabric;

export class CircleDrawAction extends FigureDrawAction {

    drawActionElement: DrawActionElement = DrawActionElement.CIRCLE;

    createCanvasElement(options?: DrawOptions): any {

        let left = 10;
        let top = 10;
        let color = 'red';
        const radius = 20;
        let borderWidth = 2;

        if (options) {

            if (options.stampingPosition) {
                left = options.stampingPosition.x;
                top = options.stampingPosition.y;
            }

            if (options.color) {
                color = options.color.getColorString();
            }

            if (options.borderWidth) {
                borderWidth = options.borderWidth;
            }

        }

        let cornerSize = DrawAction.defaults.cornerSize;

        if (this.isTouchDevice()) {
            cornerSize *= 2;
        }

        const circle = new fabric.Circle({
            radius,
            left: left - radius,
            top: top - radius,
            stroke: color,
            strokeWidth: borderWidth,
            borderColor: DrawAction.defaults.borderColor,
            cornerColor: DrawAction.defaults.cornerColor,
            cornerSize,
            transparentCorners: DrawAction.defaults.transparentCorners,
            fill: 'transparent'
        });

        return circle;
    }
}
